// removed by extract-text-webpack-plugin
module.exports = {"Calendar":"_2-bcpgTWC49TcaQqnw0p7O","CalendarOpen":"_18s4iIU6IGt8ujJRhHypHN _2-bcpgTWC49TcaQqnw0p7O","header":"_3HP3H7U8ymwt6ZlKI9wkHe","buttonCloseContainer":"_2WTaf7NjdMM5m24ZeC9g9x","centered":"_33ghb5VuoDkGdbeW2Jaeor"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Calendar/Calendar.css
// module id = 309
// module chunks = 8